import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { ModalContent, ModalHeading } from 'components/modal';

export const UpsellModalHeading = styled(ModalHeading)`
  margin-bottom: 1rem;
`;
export const UpsellModalContent = styled(ModalContent)`
  & div.modal-inner {
    display: flex;
    height: 100%;
    justify-content: flex-start;
  }
`;
export const UpsellOptionsWrapper = styled.div<{ $numColumns: number }>`
  display: grid;
  ${({ $numColumns }) => Styles.desktop`
    grid-gap: 1rem;
    grid-template-columns: repeat(${$numColumns}, 1fr);
  `}
  margin-bottom: 2rem;

  ${Styles.desktop`
    margin-bottom: 1rem;
  `}
`;

export const UpsellOption = styled.div<{ $limitWidth: boolean }>`
  background: transparent;
  border: none;
  text-align: left;

  display: grid;
  grid-template-columns: 10rem 1fr;
  grid-gap: 0.5rem;
  align-items: center;
  width: 100vw;
  height: 10rem;
  padding: 1rem;
  margin-top: 1rem;

  ${({ $limitWidth }) => Styles.desktop`
    grid-template-columns: unset;
    width: auto;
    height: auto;
    max-height: 18.75rem;
    max-width: ${$limitWidth ? '22.5rem' : 'auto'};
  `}
`;

export const TextContent = styled.div`
  height: 5.375rem;
`;

export const Title = styled.h3`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  margin: 0;
  font-family: ${Styles.fontFamily.base};
  font-weight: normal;
  font-size: 1rem;
`;

export const Description = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  margin: 0.5rem 0 0;
  font-size: 0.9rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.7rem;
  padding-bottom: 2rem;
`;

export const UpgradeContainer = styled.div<{ $center: boolean }>`
  display: none;

  ${({ $center }) => Styles.desktop`
    display: flex;
    justify-content: ${$center ? 'center' : 'space-between'};
    gap: 1rem;
    width: 100%;
    padding: 0 2rem;
    margin-bottom: 1rem;
  `}
`;

export const MobileButton = styled(ActionButton)`
  margin: 0 2rem;

  ${Styles.desktop`
    display: none;
  `}
`;
